<template>
  <div class="xs-12 m-8 l-9 myhome-profile-orders">
    <h2 class="dea-heading--medium-xxl myhome-profile-orders__title" tabindex="0">
      <template v-if="user.parent || user.student">
        I miei ordini ebook
      </template>
      <template v-else>
        I miei ordini
      </template>
    </h2>
    <div class="myhome-profile-orders__list">
      <div class="myhome-profile-orders__orders-link dea-border-grey-medium-light">
        <img :src="formazioneLogo" alt="Logo Deascuola Formazione" />
        <div class="dea-heading--light-s myhome-profile-orders__orders-link-text">
          Stai cercando un ordine fatto per un evento di Deascuola Formazione?
        </div>
        <Links
          class="dea-button dea-button--large dea-link--icon-right"
          label-class="dea-button__label"
          icon="go-to"
          type="router-link"
          :to="{ name: 'events', params: { ticketFilter: 'ordersRecap' } }"
        >
          Ordini di Deascuola Formazione
        </Links>
      </div>
      <div class="myhome-profile-orders__orders-link dea-border-grey-medium-light">
        <img :src="blackCatCidebLogo" alt="Logo Blackcat-Cideb" />
        <div class="dea-heading--light-s myhome-profile-orders__orders-link-text">
          Stai cercando un ordine fatto per un libro Blackcat-Cideb?
        </div>
        <Buttons
          class="dea-button--large dea-button--icon-right"
          icon="go-to"
          type="a"
          target="_blank"
          :href="$root.config.blackcat_cideb_login"
        >
          Ordini di Blackcat-Cideb
        </Buttons>
      </div>
    </div>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Links from "@/components/elements/Links";
import formazioneLogo from "~/assets/Formazione_horizontal_2022.svg";
import blackCatCidebLogo from "~/assets/blackcat-cideb.png";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileOrdersPanels",
  components: { Buttons, Links },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      blackCatCidebLogo,
      formazioneLogo,
    };
  },
  mounted() {
    setFocus("myhome-profile-orders__title");
  },
  activated() {
    setFocus("myhome-profile-orders__title");
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$formazione-logo-height: 70px;

.myhome-profile-orders {
  &__title {
    margin-top: 0;
  }

  &__orders-link {
    @include media("<=xs") {
      flex-wrap: wrap;
      justify-content: center;
    }
    align-items: center;
    border: $border-light;
    border-radius: $border-radius-medium;
    display: flex;
    padding: $space-base;

    &-text {
      @include media("<=xs") {
        margin: $space-small 0;
        text-align: center;
      }
      margin: 0 $space-base;
    }

    &:first-of-type {
      margin-bottom: $space-base;

      img {
        height: $formazione-logo-height;
      }

      .dea-links__icon {
        color: $dea-color-white;
      }
    }
  }
}
</style>
